import { __extends, __read, __spread, __values } from "tslib";
import { Connectable } from '../Connectable';
var PortalStore = /** @class */ (function (_super) {
    __extends(PortalStore, _super);
    function PortalStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._portalMap = new Map();
        _this._batchMode = false;
        return _this;
    }
    Object.defineProperty(PortalStore.prototype, "size", {
        get: function () {
            return this._portalMap.size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortalStore.prototype, "lastPortal", {
        get: function () {
            var e_1, _a;
            var lastPortal;
            try {
                for (var _b = __values(this.portals), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var portal = _c.value;
                    lastPortal = portal;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return lastPortal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortalStore.prototype, "portals", {
        get: function () {
            return this._portalMap.values();
        },
        enumerable: true,
        configurable: true
    });
    PortalStore.prototype.addOrUpdate = function (portal) {
        this._portalMap.set(portal.id, portal);
        if (!this._batchMode)
            this._emitChanges();
    };
    PortalStore.prototype.delete = function (id) {
        this._portalMap.delete(id);
        if (!this._batchMode)
            this._emitChanges();
    };
    PortalStore.prototype.clear = function () {
        this._portalMap.clear();
        if (!this._batchMode)
            this._emitChanges();
    };
    PortalStore.prototype.has = function (id) {
        return this._portalMap.has(id);
    };
    PortalStore.prototype.get = function (id) {
        return this._portalMap.get(id);
    };
    PortalStore.prototype.batch = function (handle) {
        this._batchMode = true;
        try {
            handle(this);
        }
        finally {
            this._batchMode = false;
            this._emitChanges();
        }
    };
    /**
     * just notify portal host rerender view
     */
    PortalStore.prototype.forceEmit = function () {
        this._emitChanges();
    };
    PortalStore.prototype._emitChanges = function () {
        this.emit(__spread(this.portals));
    };
    return PortalStore;
}(Connectable));
export { PortalStore };
